import { getExperimentValue } from '@canvas/client-feature-flags/experiments';

interface UseIsAiSummaryFieldEnabledOptions {
  fireExperimentExposure?: boolean;
}

export const useIsAiSummaryFieldEnabled = ({
  fireExperimentExposure = false
}: UseIsAiSummaryFieldEnabledOptions = {}) =>
  getExperimentValue('databasesFrontendAiFieldsSummary', 'enabled', {
    fireExperimentExposure
  });
